import * as Yup from "yup";

export const initialValues = {
  name: "",
  email: "",
  password: "",
};

export const validationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email address")
    .matches(/@/, "Email must contain '@'")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const settingInitialValues = {
  email: "",
  password: "",
};

export const settingValidationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required("Email is required")
    .test(
      "includes-at",
      "Email must contain '@'",
      (value) => value && value.includes("@"),
    )
    .email("Please enter a valid email address"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const detailsInitialValues = {
  name: "",
  phoneNumber: [""],
};

export const detailsValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
});

export const profileInitialValues = {
  name: "",
  phoneNumber: [""],
  timezone: "UTC",
};

export const profileValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  phoneNumber: Yup.array().of(
    Yup.string()
      .nullable()
      .test(
        "valid-or-empty",
        "Invalid phone number format",
        (value) => !value || value.trim() === "" || value.startsWith("+"),
      ),
  ),
});
